module.exports = __webpack_public_path__ + "media/images/icons/youtube-2720726211a2311872dda658b8de5407.svg";